import React, { FC, useEffect, useState } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { PlaceAutocomplete } from "components/GoogleMaps/PlaceAutocomplete";
import type { PlaceResult } from "components/GoogleMaps/PlaceAutocomplete";
import AddressInputMiniMap from "components/GoogleMaps/AddressInputMiniMap";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetBorgoQuery } from "application/features/borghi/borghiApiSlice";
import { selectCurrentExperience, setExperience } from "application/features/experience/experienceSlice";


export interface PageAddListing2Props { }

const PageAddExperience2: FC<PageAddListing2Props> = () => {

  const [next, setNext] = useState("/host/new-experience/add-listing-3");
  const [getBorgo, { data, isLoading }] = useLazyGetBorgoQuery({});

  const experience = useSelector(selectCurrentExperience);
  const dispatch = useDispatch();

  const handleUpdateExperience = (field: string, value: any) => {
    try {
      dispatch(setExperience({ ...experience, [field]: value }))
    }
    catch (e) {
      console.log(e)
    }
  };

  const [selectedPlace, setSelectedPlace] =
    useState<PlaceResult | null>({
      latitude: experience?.location?.latitude || 41.9027,
      longitude: experience?.location?.longitude || 12.4963,
  });

  const cityInputRef = React.useRef<HTMLInputElement>(null);
  const countryInputRef = React.useRef<HTMLInputElement>(null);
  const postalCodeInputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!selectedPlace) {
      return;
    }

    const updatedExperience = {
      ...experience,
      location: {
        latitude: selectedPlace.latitude,
        longitude: selectedPlace.longitude,
      },
      city: selectedPlace.city,
      state: selectedPlace.country,
      postal_code: selectedPlace.postal_code,
      address: selectedPlace.formatted_address,
      country: selectedPlace.province,
      region: selectedPlace.region,
    };

    // Automatically update the form fields based on the selected place
    if (cityInputRef.current) {
      cityInputRef.current.value = selectedPlace.city || "";
    }
    if (countryInputRef.current) {
      countryInputRef.current.value = selectedPlace.country || "";
    }
    if (postalCodeInputRef.current) {
      postalCodeInputRef.current.value = selectedPlace.postal_code || "";
    }

    dispatch(setExperience(updatedExperience));


  }, [selectedPlace]);

  useEffect(() => {
    if (experience.city) {
      handleGetBorgo(experience.city)
    }
  }, [experience.city]);

  const handleGetBorgo = async (city: string) => {
    try {
      const data = await getBorgo(city.toLowerCase()).unwrap();
      if (!data?.borgo?.name) {
        setNext("/host/new-experience/add-listing-borgo-intro")
      } else {
        setNext("/host/new-experience/add-listing-3")
      }
    } catch (e) {
      console.log(e)
    }
  };

  return (
    <CommonLayout
      index="02"
      nextHref={next}
      backtHref="/host/new-experience/add-listing-1"
      canGoNext={(selectedPlace.city !== undefined) && (selectedPlace.country !== undefined) && (selectedPlace.postal_code !== undefined)}
    >
      <>
        <h2 className="text-2xl font-semibold">Dove si svolge l'esperienza?</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          <FormItem label="Indirizzo">
            <PlaceAutocomplete
              onPlaceSelect={setSelectedPlace}
              placeholder="Cerca un indirizzo"
            />
          </FormItem>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-5">
            <FormItem label="Città">
              <Input
                onChange={(e) => handleUpdateExperience("city", e.target.value)}
                value={experience.city || ""}
                ref={cityInputRef}
              />
            </FormItem>
            <FormItem label="Provincia">
              <Input
                onChange={(e) => handleUpdateExperience("country", e.target.value)}
                ref={countryInputRef}
                value={experience.country || ""}
              />
            </FormItem>
            <FormItem label="CAP">
              <Input
                onChange={(e) => handleUpdateExperience("postal_code", e.target.value)}
                value={experience.postal_code || ""}
                ref={postalCodeInputRef}
              />
            </FormItem>
          </div>
          <div>
            <div className="my-4">
              <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
                <AddressInputMiniMap
                  className=""
                  defaultCenter={{ lat: selectedPlace.latitude, lng: selectedPlace.longitude }}
                  place={selectedPlace}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddExperience2;
